<a href="https://www.facebook.com/vandyhacks" target="_blank">
    <svg
        width="36"
        height="35"
        viewBox="0 0 36 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="w-8 md:w-9 lg:w-10 h-8 md:h-9 lg:h-10 hover:cursor-pointer"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.507812 17.5977C0.507812 26.2981 6.82677 33.5329 15.0911 35V22.3606H10.7161V17.5H15.0911V13.6106C15.0911 9.23563 17.9101 6.80604 21.8972 6.80604C23.1601 6.80604 24.5222 7 25.7851 7.19396V11.6667H23.5495C21.4101 11.6667 20.9245 12.7356 20.9245 14.0977V17.5H25.5911L24.8139 22.3606H20.9245V35C29.1889 33.5329 35.5078 26.2996 35.5078 17.5977C35.5078 7.91875 27.6328 0 18.0078 0C8.38281 0 0.507812 7.91875 0.507812 17.5977Z"
            fill="#694C15"
        />
    </svg>
</a>
